module.exports = __webpack_public_path__ + "img/pressure.a83d7d59.svg";